import { render, staticRenderFns } from "./EditJst.vue?vue&type=template&id=3191e8c6&scoped=true"
import script from "./EditJst.vue?vue&type=script&lang=js"
export * from "./EditJst.vue?vue&type=script&lang=js"
import style0 from "./EditJst.vue?vue&type=style&index=0&id=3191e8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3191e8c6",
  null
  
)

export default component.exports